"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageDataAuditFailedEvent = exports.PackageDataAuditCompletedEvent = void 0;
const zod_1 = require("zod");
const event_1 = require("../event");
const edit_provenance_types_1 = require("../../Auth/edit-provenance.types");
const property_key_1 = require("../../Consensus/property-key");
const slice_key_1 = require("../../Consensus/slice-key");
const package_data_audit_types_1 = require("../../PackageDataAdjudication/package-data-audit.types");
const packageDataAuditEventBase = {
    auditId: zod_1.z.string(),
    packageId: zod_1.z.string(),
    propertyKey: zod_1.z.nativeEnum(property_key_1.PropertyKey),
    channel: zod_1.z.nativeEnum(edit_provenance_types_1.EditAgency),
    actorUserId: zod_1.z.string().optional(),
    conversationId: zod_1.z.string().optional(),
    parentConversationId: zod_1.z.string().optional(),
    projectId: zod_1.z.string().optional(),
    buildId: zod_1.z.string().optional(),
    agentId: zod_1.z.string().optional(),
    durationMs: zod_1.z.number().int(),
    itemCount: zod_1.z.number().int(),
};
const packageDataAuditEventItem = zod_1.z.object({
    status: zod_1.z.nativeEnum(package_data_audit_types_1.PackageDataAuditItemStatus),
    subject: zod_1.z.string(),
    opinionValue: zod_1.z.string().optional(),
});
exports.PackageDataAuditCompletedEvent = (0, event_1.createEventClass)('PackageDataAuditCompletedEvent', zod_1.z.object({
    ...packageDataAuditEventBase,
    status: zod_1.z.nativeEnum(package_data_audit_types_1.PackageDataAuditStatus),
    sliceKey: zod_1.z.nativeEnum(slice_key_1.SliceKey).optional(),
    sliceVersion: zod_1.z.number().int().optional(),
    adjudicatedCount: zod_1.z.number().int(),
    pendingCount: zod_1.z.number().int(),
    notAdjudicatedCount: zod_1.z.number().int(),
    dispatched: zod_1.z.boolean(),
    requestIds: zod_1.z.string().array(),
    planIds: zod_1.z.string().array(),
    opinionCount: zod_1.z.number().int(),
    items: packageDataAuditEventItem.array(),
}));
exports.PackageDataAuditFailedEvent = (0, event_1.createEventClass)('PackageDataAuditFailedEvent', zod_1.z.object({ ...packageDataAuditEventBase, errorMessage: zod_1.z.string() }));
//# sourceMappingURL=package-data-audit-events.js.map